import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

import type { PhysicalFitnessAssessment } from "~/api/physicalFitnessAssessments";
import { PushUp } from "~/icons";
import { PerformanceDetails } from ".";

interface PushUpSectionProps {
  lastPFA: PhysicalFitnessAssessment;
}

export const PushUpSection = ({ lastPFA }: PushUpSectionProps) => {
  const { t } = useTranslation();

  const qualified = lastPFA.push_up_score != 0;

  const totalScore = lastPFA.push_up_score / 10;

  return (
    <PerformanceDetails.Section>
      <PerformanceDetails.Subtitle className="pb-4">
        {t("pfas.push_up")}
      </PerformanceDetails.Subtitle>
      <PerformanceDetails.Card>
        <PerformanceDetails.CardHeader>
          <PerformanceDetails.CardTitle>
            <PushUp
              className={twMerge(
                qualified
                  ? "text-primary-40 dark:text-primary-80"
                  : "text-warning-95",
              )}
            />
            <PerformanceDetails.Subtitle
              className={twMerge(
                qualified
                  ? "text-primary-40 dark:text-primary-80"
                  : "text-warning-95",
              )}
            >
              {t(`pfas.${lastPFA.push_up_option}`)}
            </PerformanceDetails.Subtitle>
          </PerformanceDetails.CardTitle>
          <PerformanceDetails.QualifiedTag
            className={twMerge(
              qualified
                ? "bg-info-50 dark:bg-info-30"
                : "bg-warning-80 text-black",
            )}
          >
            {qualified ? t("pfas.qualified") : t("pfas.not_qualified")}
          </PerformanceDetails.QualifiedTag>
        </PerformanceDetails.CardHeader>
        <PerformanceDetails.CardBody>
          <PerformanceDetails.CardResult>
            <PerformanceDetails.CardResultValue className="">
              {t("pfas.repetitions")}
            </PerformanceDetails.CardResultValue>
            <PerformanceDetails.CardResultValue className="pt-2">
              {t("pfas.reps", { reps: lastPFA.push_up_value })}
            </PerformanceDetails.CardResultValue>
          </PerformanceDetails.CardResult>
          <PerformanceDetails.CardResult>
            <PerformanceDetails.CardResultValue className="">
              {t("pfas.score")}
            </PerformanceDetails.CardResultValue>
            <PerformanceDetails.CardResultValue className="pt-2">
              {t("pfas.over_20_points", { totalScore: totalScore })}
            </PerformanceDetails.CardResultValue>
          </PerformanceDetails.CardResult>
        </PerformanceDetails.CardBody>
      </PerformanceDetails.Card>
    </PerformanceDetails.Section>
  );
};
